import {HEADER_HEIGHT_DESKTOP, HEADER_HEIGHT_MOBILE, NAVIGATE_WIDTH_DESKTOP} from "@view/constants/size";
import {SxType} from "@baseTypes/sx/sxTypes";

export const sx:SxType = {
    container: {
        display: "grid",
        gridTemplateAreas: {
            xs:'"header"\n          "content"',
            lg:'"header header"\n        "sidebar content"'
        },
        gridTemplateRows: "auto 1fr",
        gridTemplateColumns: {
            xs:'1fr',
            lg:`${NAVIGATE_WIDTH_DESKTOP} 1fr`
        },
        height: "100vh",
        '&.lightTheme':{
            backgroundColor:'rgba(230, 230, 230, 1)'
        },
        '&.hideSidebar':{
            gridTemplateColumns:"1fr",
            gridTemplateAreas:'"header"\n          "content"'
        }
    },
    header: {
        gridArea: "header",
        height: {
            xs: HEADER_HEIGHT_MOBILE,
            xl: HEADER_HEIGHT_DESKTOP
        }
    },
    sidebar: {
        gridArea: "sidebar",
        overflowY:'auto',
        maxHeight:'100%',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {display: 'none'},
    },
    content: {
        gridArea: "content",
        overflowY:'auto',
    }
}